// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Containers */

/* The top level container for an Escher Builder */
.escher-container {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  background-color: #F3F3F3;
  text-align: center;
  position: relative;
  font-size: 14px;
  color: #333333;
}

/* Applied to the body when Escher fills the screen. This stops browser from
showing scroll-end animations. */
html.fill-screen {
  height: 100%;
  width: 100%;
}
body.fill-screen {
  margin: 0;
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
}

/* Applied to top level container (generally .escher-container) when Escher
fills the screen. These make sure Escher completely fills the screen, even after
resizes. */
.fill-screen-div {
  margin: 0;
  padding: 0;
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  width: 100% !important;
  height: 100% !important;
  z-index: 1000;
}

/* The zoom container classes. */
.escher-container .escher-zoom-container,
.escher-container .escher-3d-transform-container,
.escher-container svg.escher-svg {
  width: 100% !important;
  height: 100% !important;
  overflow: hidden;
}

/* SVG text should not be selectable */
.escher-container svg text {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Status */
.escher-container #status {
  position:absolute;
  bottom:10px;
  left: 20px;
  color: red;
  background-color: white;
  font-size: 16px
}

/* Search & Menu */
.escher-container .search-menu-container {
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0px;
  margin: 0;
  text-align: center;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.escher-container .search-menu-container .legend-container{
  display: none;
  width: 224px;
  height: 35.5px;
}

.escher-container .search-menu-container .vertical-legend-container{
  display: none;
}

.escher-container .search-menu-container-inline {
  box-sizing: border-box;
  width: 320px;
  display: inline-block;
  text-align: left;
  pointer-events: auto;
}
@media (min-width: 550px) {
  .escher-container .search-menu-container-inline {
    width: 470px;
  }
}

/* Reaction input */
.escher-container #rxn-input {
  z-index: 10;
  width: 200px;
}
.escher-container .input-close-button {
  position: absolute;
  right: 0px;
  width: 18px;
  bottom: 0px;
  padding: 0px;
  border-width: 0px;
  margin: 0px;
  background: none;
  font-size: 20px;
  font-weight: normal;
  top: -8px;
}
.escher-container .input-close-button:hover {
  color: #ff3333;
  font-weight: bold;
}

/* text edit input */
.escher-container #text-edit-input input {
  width: 500px;
  border: 1px solid #cccccc;
  font-size: 22px;
}

.escher-container #tooltip-container {
  -ms-touch-action: none;
  touch-action: none;
}

/* Buttons */
.escher-container .btn {
  color: white!important;
  border: 1px solid #2E2F2F;
  background-image: linear-gradient(#4F5151, #474949 6%, #3F4141);
  background-color: white;
  cursor: pointer;
}

.escher-container .btn:active {
  background-image: linear-gradient(#3F4141, #474949 6%, #4F5151);
}


/* Modal container */
#legend-config-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  padding: 20px;
  background-color: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  display: none; /* Hidden by default */
  border-radius: 8px;
  border: 1px solid #ccc;
}

#legend-config-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black */
  z-index: 1000; /* Ensure the overlay is behind the modal */
  display: none; /* Hidden by default */
}

/* Modal content */
#legend-config-modal .modal-content h3 {
  font-size: 1.25em;
  margin-bottom: 20px;
  margin-top: 0;
}

#legend-config-modal .modal-content label {
  display: block;
  margin: 10px 0 5px;
  font-weight: bold;
  text-align: left;
}

#legend-config-modal .modal-content select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* Modal actions */
#legend-config-modal .modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

#legend-config-modal .modal-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
}

#legend-config-modal .modal-button.confirm {
  background-color: #4CAF50;
  color: white;
}

#legend-config-modal .modal-button.cancel {
  background-color: #f2f2f2;
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/Builder.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf,kDAAkD;AAClD;EACE,sEAAsE;EACtE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;gCACgC;AAChC;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;;UAEU;AACV;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;AACf;;AAEA,gCAAgC;AAChC;;;EAGE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,UAAU;EACV,uBAAuB;EACvB;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,sBAAsB;EACtB,yBAAyB;EACzB,+DAA+D;EAC/D,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,+DAA+D;AACjE;;;AAGA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,0CAA0C;EAC1C,aAAa;EACb,aAAa,EAAE,sBAAsB;EACrC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,2BAA2B;EACjE,aAAa,EAAE,2CAA2C;EAC1D,aAAa,EAAE,sBAAsB;AACvC;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb","sourcesContent":["/* Containers */\n\n/* The top level container for an Escher Builder */\n.escher-container {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n  background-color: #F3F3F3;\n  text-align: center;\n  position: relative;\n  font-size: 14px;\n  color: #333333;\n}\n\n/* Applied to the body when Escher fills the screen. This stops browser from\nshowing scroll-end animations. */\nhtml.fill-screen {\n  height: 100%;\n  width: 100%;\n}\nbody.fill-screen {\n  margin: 0;\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n}\n\n/* Applied to top level container (generally .escher-container) when Escher\nfills the screen. These make sure Escher completely fills the screen, even after\nresizes. */\n.fill-screen-div {\n  margin: 0;\n  padding: 0;\n  position: fixed;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  width: 100% !important;\n  height: 100% !important;\n  z-index: 1000;\n}\n\n/* The zoom container classes. */\n.escher-container .escher-zoom-container,\n.escher-container .escher-3d-transform-container,\n.escher-container svg.escher-svg {\n  width: 100% !important;\n  height: 100% !important;\n  overflow: hidden;\n}\n\n/* SVG text should not be selectable */\n.escher-container svg text {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Status */\n.escher-container #status {\n  position:absolute;\n  bottom:10px;\n  left: 20px;\n  color: red;\n  background-color: white;\n  font-size: 16px\n}\n\n/* Search & Menu */\n.escher-container .search-menu-container {\n  position: absolute;\n  width: 100%;\n  top: 0px;\n  left: 0px;\n  margin: 0;\n  text-align: center;\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.escher-container .search-menu-container .legend-container{\n  display: none;\n  width: 224px;\n  height: 35.5px;\n}\n\n.escher-container .search-menu-container .vertical-legend-container{\n  display: none;\n}\n\n.escher-container .search-menu-container-inline {\n  box-sizing: border-box;\n  width: 320px;\n  display: inline-block;\n  text-align: left;\n  pointer-events: auto;\n}\n@media (min-width: 550px) {\n  .escher-container .search-menu-container-inline {\n    width: 470px;\n  }\n}\n\n/* Reaction input */\n.escher-container #rxn-input {\n  z-index: 10;\n  width: 200px;\n}\n.escher-container .input-close-button {\n  position: absolute;\n  right: 0px;\n  width: 18px;\n  bottom: 0px;\n  padding: 0px;\n  border-width: 0px;\n  margin: 0px;\n  background: none;\n  font-size: 20px;\n  font-weight: normal;\n  top: -8px;\n}\n.escher-container .input-close-button:hover {\n  color: #ff3333;\n  font-weight: bold;\n}\n\n/* text edit input */\n.escher-container #text-edit-input input {\n  width: 500px;\n  border: 1px solid #cccccc;\n  font-size: 22px;\n}\n\n.escher-container #tooltip-container {\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n/* Buttons */\n.escher-container .btn {\n  color: white!important;\n  border: 1px solid #2E2F2F;\n  background-image: linear-gradient(#4F5151, #474949 6%, #3F4141);\n  background-color: white;\n  cursor: pointer;\n}\n\n.escher-container .btn:active {\n  background-image: linear-gradient(#3F4141, #474949 6%, #4F5151);\n}\n\n\n/* Modal container */\n#legend-config-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 400px;\n  padding: 20px;\n  background-color: white;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1001;\n  display: none; /* Hidden by default */\n  border-radius: 8px;\n  border: 1px solid #ccc;\n}\n\n#legend-config-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black */\n  z-index: 1000; /* Ensure the overlay is behind the modal */\n  display: none; /* Hidden by default */\n}\n\n/* Modal content */\n#legend-config-modal .modal-content h3 {\n  font-size: 1.25em;\n  margin-bottom: 20px;\n  margin-top: 0;\n}\n\n#legend-config-modal .modal-content label {\n  display: block;\n  margin: 10px 0 5px;\n  font-weight: bold;\n  text-align: left;\n}\n\n#legend-config-modal .modal-content select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n/* Modal actions */\n#legend-config-modal .modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n#legend-config-modal .modal-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n#legend-config-modal .modal-button.confirm {\n  background-color: #4CAF50;\n  color: white;\n}\n\n#legend-config-modal .modal-button.cancel {\n  background-color: #f2f2f2;\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
